// Season utility functions for validating date and season alignment

/**
 * Calculate season from a given date string
 * Cherry season: July (month 6) to June (month 5) next year
 */
export const calculateSeasonFromDate = (dateString: string): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const month = date.getMonth(); // 0-11
  const year = date.getFullYear();
  
  // Cherry season: July (month 6) to June (month 5) next year
  if (month >= 6) {
    // July onwards: current year - next year
    return `${year}-${year + 1}`;
  } else {
    // January to June: previous year - current year
    return `${year - 1}-${year}`;
  }
};
/**
 * Check if season and date are aligned
 */
export const isSeasonDateAligned = (dateSold: string, season: string): boolean => {
  if (!dateSold || !season) return true;
  const calculatedSeason = calculateSeasonFromDate(dateSold);
  return calculatedSeason === season;
};

/**
 * Get season mismatch message
 */
export const getSeasonMismatchMessage = (dateSold: string, season: string): string => {
  if (!dateSold || isSeasonDateAligned(dateSold, season)) return '';
  const calculatedSeason = calculateSeasonFromDate(dateSold);
  return `⚠️ La fecha de venta corresponde a la temporada ${calculatedSeason}, pero tienes seleccionada ${season}`;
}; 